<template>
  <q-btn
    :size="fontSize"
    :outline="buttonType === BUTTON_TYPES.OUTLINE"
    :class="getClasses(buttonType, buttonColor, buttonColorHex)"
    :style="getStyles(buttonType, buttonColor, buttonColorHex, buttonBorderRadius)"
    :push="buttonType === BUTTON_TYPES.STANDARD"
    @click="$emit('click-button')"
  >
    <slot name="button-label" />
  </q-btn>
</template>
<script>

import { TEXT_POSITION_TYPES } from 'src/models/carousel/Carousel'
import { BUTTON_TYPES } from 'src/models/page/Section'
export default {
  name: 'SectionButton',
  props: {
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.STANDARD
    },
    buttonColor: {
      type: String,
      required: true
    },
    buttonColorHex: {
      type: String,
      required: true
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: null
    },
    textPositionType: {
      type: String,
      required: false,
      default: null
    },
    fontSize: {
      type: String,
      required: false,
      default: '16px'
    }
  },
  emits: ['click-button'],
  created () {
    _.extend(this, { BUTTON_TYPES, TEXT_POSITION_TYPES })
  },
  configuration: ['currentSite'],
  methods: {
    getClasses (button, color, colorHex) {
      const classes = []

      // Handle STANDARD and UNELEVATED button types
      if (button === BUTTON_TYPES.STANDARD || button === BUTTON_TYPES.UNELEVATED) {
        if (color === 'default') {
          classes.push('text-grey')
        } else if (color !== 'custom') {
          classes.push(`bg-${color}`)
          classes.push(this.$getTextColor(this.currentSite, color))
        } else if (color === 'custom' && colorHex) {
          classes.push(this.$isColorDark(colorHex) ? 'text-white' : 'text-black')
        }
      }

      // Handle FLAT and OUTLINE button types
      if (button === BUTTON_TYPES.FLAT || button === BUTTON_TYPES.OUTLINE) {
        if (color !== 'custom') {
          classes.push(`text-${color}`)
        }
        if (this.textPositionType === TEXT_POSITION_TYPES.BOTTOM_MARGIN) {
          classes.push('bg-color')
        }
      }

      return classes.join(' ')
    },
    getStyles (button, color, colorHex, borderRadius) {
      const styles = []

      if (borderRadius !== null) {
        styles.push(`border-radius: ${borderRadius}px`)
      }
      if ((button === BUTTON_TYPES.STANDARD || button === BUTTON_TYPES.UNELEVATED) && color === 'custom') {
        styles.push(`background-color: ${colorHex}`)
      }
      if ((button === BUTTON_TYPES.FLAT || button === BUTTON_TYPES.OUTLINE) && color === 'custom') {
        styles.push(`color: ${colorHex}`)
      }

      return styles.join(';')
    }
  }
}
</script>
<style lang="scss" scoped>
  .bg-color {
    background-color: $background !important;
  }
</style>
